import { Route } from 'react-router';
import { Page } from '@roc/feature-app-core';
import { LoansInPendingStatusDashboard } from '../components';

export const getLoansInPendingStatusRoutesConfig = (basePath: string, baseUrl: string) => {
  return {
    loansInPendingStatusDashboard: {
      path: `${basePath}/loans-pending-status/dashboard`,
      url: `${baseUrl}/loans-pending-status/dashboard`,
      documentTitle: 'Loans In Pending Status Dashboard',
    },
  };
};

export const getLoansInPendingStatusRoutes = (basePath: string, baseUrl: string) => {
  const config = getLoansInPendingStatusRoutesConfig(basePath, baseUrl);

  return {
    loansInPendingStatusDashboard: (
      <Route exact path={config.loansInPendingStatusDashboard.path}>
        <Page routeDefinition={config.loansInPendingStatusDashboard}>
          <LoansInPendingStatusDashboard />
        </Page>
      </Route>
    ),
  };
};